import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import { paymentIcons, icons } from './icons';
import { FareFeaturePaymentType } from '@websky/graphql';
import { Form } from '@websky/core/src/Checkout/components/Checkout/Form/Form';
import OrderMultipleBusinessBlockSlot from '@websky/core/src/Checkout/components/Checkout/OrderMultipleBusinessBlockSlot/OrderMultipleBusinessBlockSlot';
import Details from '@websky/core/src/Meal/components/Details/Details';
import FfpInfoStatusesMaxLevel from './Loyalty/FfpInfoStatusesMaxLevel/FfpInfoStatusesMaxLevel';
import ExchangeFlight from './Exchange/Flight/Flight';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';

export const izaviaRenderers: EngineRenderers = {
	FfpInfoStatusesMaxLevel: FfpInfoStatusesMaxLevel,
	Paid: () => paymentIcons[FareFeaturePaymentType.Pay],
	CheckoutForm: props => <Form {...props} showCheckDataModal={true} />,
	CheckoutBusiness: OrderMultipleBusinessBlockSlot,
	MealDetails: props => <Details {...props} isDescriptionOpened={true} />,
	ExchangeFlight,
	CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
	...icons
};
